export default __webpack_public_path__ + "static/content-curator-71182ffb1c4fc360d947b7bd29e477fa.svg";